function animateMenuIcon() {
    const nav = $(".main-navigation");
    const navBG = $(".navigation-container");

    $(".main-menu-button").on("click", function() {
        nav.addClass("open");
        navBG.addClass("open");
    });

    $(".close-nav").on("click", function() {
        event.preventDefault();
        nav.removeClass("open");
        navBG.removeClass("open");
    });

    $(".navigation-container--close").on("click", function() {
        nav.removeClass("open");
        navBG.removeClass("open");
    });
}

function photogallery() {
    $(".gallery-slider--close").on("click", function() {
        $(".gallery-slider").fadeOut();
        $('.gallery-slider-box').slick("unslick");
    });

    $(".article-gallery").children("li").on("click", function() {
        let currentSlide = $(this).data("image");

        $(".gallery-slider").fadeIn();
        $('.gallery-slider-box').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            lazyLoad: 'ondemand',
            fade: true,
            cssEase: 'linear',
            initialSlide: parseInt(currentSlide)
        });
    });
}

animateMenuIcon();
photogallery();